import { InnerContent } from '@/components/atoms/InnerContent/InnerContent';
/*
import { useWindowSize } from '@/hooks';
import { breakpointValues } from '@/theme/breakpoint';
*/
const serviceTypesMap: { [key: string]: any } = {
  Residential: {
    icon: 'couch',
    iconType: 'fas',
    iconSize: '2x',
    label: 'Residential care',
    description:
      'Accommodation, meals, and assistance with personal care and medication.',
    color: 'green',
  },
  Nursing: {
    icon: 'user-nurse',
    iconType: 'fas',
    iconSize: '2x',
    label: 'Nursing care',
    description:
      'Medical care from a qualified nurse, and treatment for residents with illness or injuries.',
    color: 'green',
  },
  Palliative: {
    icon: 'hand-holding-heart',
    iconSize: '2x',
    iconType: 'fas',
    label: 'Palliative and end of life care',
    description:
      'Care designed to provide quality support and comfort for people living with life-limiting conditions.',
    color: 'green',
  },
  Dementia: {
    icon: 'hands-helping',
    iconSize: '2x',
    iconType: 'fas',
    label: 'Dementia',
    color: 'green',
    description:
      'Specialist care designed to meet the challenges faced by people living with dementia.',
  },
};

interface CareServiceTypesProps {
  serviceTypes: string[];
}
export const CareServiceTypes = ({ serviceTypes }: CareServiceTypesProps) => {
  // hooks
  // const [width] = useWindowSize();

  return (
    <InnerContent
      size='md'
      maxColumns={1}
      items={serviceTypes
        .map((serviceType) => serviceTypesMap[serviceType])
        .filter((item) => item)
        .map((item) => ({
          ...item,
          title: item.label,
          description: item.description,
          iconSize: item.iconSize || '1x',
          iconColor: item.color as any,
        }))}
    />
  );
};

export default CareServiceTypes;
